import { SignatureRequests } from "@/components/features/matter/file-repo/signature-requests/SignatureRequests";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/signature-requests",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  return <SignatureRequests matter={matter} />;
}
